import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { PassingModeRepository } from '@/store/passing-mode-state/passing-mode-state.repository';

interface IPassingModeUpdateDrawerObjectProps {
  store?: PassingModeRepository;
  formObject?: DynamicForm;
  action?: () => void;
  toggleVisibility?: () => void;
}

export const getPassingModeUpdateDrawerObject = ({ store, formObject, toggleVisibility, action }: IPassingModeUpdateDrawerObjectProps): any => {
  return {
    title: 'settings.passingMode.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.passingMode.update.update',
        onClick: () => action?.(),
      },
      {
        label: 'settings.passingMode.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
